export { default as component } from "../../../../src/routes/[prefix]/(feature)/order-recap/+page.svelte";